import { createContext, type ReactNode } from "react";
import { useGetConfig } from "../../repositories/queries/group/get-config.query";
import { IConfig } from "./config";

interface IConfigContextType {
  appConfig: IConfig | undefined;
}

const ConfigContext = createContext<IConfigContextType>({} as IConfigContextType);

interface IConfigProviderProps {
  children: ReactNode;
}

export const ConfigProvider = (props: IConfigProviderProps) => {
  const value = useConfigProvider();
  return <ConfigContext.Provider value={value}>{props.children}</ConfigContext.Provider>;
};

const useConfigProvider = (): IConfigContextType => {
  const { data: appConfig } = useGetConfig();
  return { appConfig };
};
